module.exports = __webpack_public_path__ + "img/headLeft5Logo.beca785c.png";